export default __webpack_public_path__ + "33f150c6ac81219f18b55864e087dd12.woff";